import type { FormGenerator } from "../../Form/GenerateForm";

import { importGenerator } from "./GeneratorRequireUtils";
import { GeneratorPool } from "./GeneratorPool";

class GeneratorAsyncProxy implements FormGenerator {
    private readonly generatorPath: string;
    private pool?: GeneratorPool;

    public readonly readSources: FormGenerator["readSources"];

    public readonly getAllDependenciesHash: FormGenerator["getAllDependenciesHash"];
    public readonly getDictionary: FormGenerator["getDictionary"];
    public readonly getLocalizedSugar: FormGenerator["getLocalizedSugar"];

    public constructor(generatorPath: string) {
        this.generatorPath = generatorPath;
        const generator = importGenerator(generatorPath);
        this.readSources = generator.readSources;
        this.getAllDependenciesHash = generator.getAllDependenciesHash;
        this.getDictionary = generator.getDictionary;
        this.getLocalizedSugar = generator.getLocalizedSugar;
    }

    public readonly readSourcesAndProcessSugar: FormGenerator["readSourcesAndProcessSugar"] = async task => {
        if (!this.pool) {
            this.pool = new GeneratorPool(this.generatorPath);
        }
        return this.pool.generate(task);
    };

    public async dispose(): Promise<void> {
        await this.pool?.dispose();
        this.pool = undefined;
    }
}

export const createAsyncGenerator = (generatorPath: string): FormGenerator => new GeneratorAsyncProxy(generatorPath);
